import {FORM_CONSTRAINTS} from "./index";

export const EMAIL_CANT_BE_EMPTY = 'The email can\'t be empty.';
export const EMAIL_INVALID_FORMAT = 'Invalid email format';

export const USERNAME_CANT_BE_EMPTY = 'The username can\'t be empty';
export const USERNAME_SHOULD_BE_BETWEEN = `Username must be between ${FORM_CONSTRAINTS.username.min_length} and  ${FORM_CONSTRAINTS.username.max_length} characters.`;

export const PASSWORD_LENGTH_NOT_VALID = `The password must be between ${FORM_CONSTRAINTS.password.min_length} and ${FORM_CONSTRAINTS.password.max_length} characters.`;
export const PASSWORD_MUST_CONTAIN_BOTH_LETTERS_NUMBERS = 'The password must contain both letters and numbers.';
export const PASSWORD_MUST_NOT_CONTAIN_PERSONAL_INFO = 'The password can\'t contain personal information eg. name, username, email.';
export const PASSWORD_CANT_BE_EMPTY = 'The password can\'t be empty.';

export const FIRST_NAME_CANT_BE_EMPTY = 'The first name can\'t be empty.';
export const FIRST_NAME_NOT_ALLOW = 'The first name can\'t contain any numbers or special characters.';
export const FIRST_NAME_SHOULD_BE_BETWEEN = `The first name must be between ${FORM_CONSTRAINTS.first_name.min_length} and ${FORM_CONSTRAINTS.first_name.max_length} characters.`;

export const FIRST_NAME_SAME_TO_SURNAME = 'The first name and surname can\'t be the same.';

export const SURNAME_CANT_BE_EMPTY = 'The surname can\'t be empty.';
export const SURNAME_NOT_ALLOW = 'The surname can\'t contain any numbers or special characters.';
export const SURNAME_SHOULD_BE_BETWEEN = `The surname must be between ${FORM_CONSTRAINTS.surname.min_length} and ${FORM_CONSTRAINTS.surname.max_length} characters.`;

export const BIRTHDATE_ENTER_VALID = 'The date of birth is invalid (DD/MM/YYYY).';
export const BIRTHDATE_OVER_18 = 'You must be over 18 to create an account.';

export const MOBILE_NUMBER_CANT_BE_EMPTY = 'The mobile number can\'t be empty';
export const MOBILE_NUMBER_10_DIGITS = 'The mobile number must be 10 digits.';
export const MOBILE_TRY_LATER = 'Time or resend OTP expired. Try later.';
export const OTP_RESEND_SESSION = 'This session will expire in {time}. Please enter the OTP code.';
